import { Router } from '@angular/router';
import { AuthStoreFacade } from './auth-store.facade';
import { Injectable } from '@angular/core';
import { filter, take, pluck } from 'rxjs/operators';
import { PostAuthDTO } from '@portal-front-end/models';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private authStore: AuthStoreFacade, private router: Router) { }

    login(login: PostAuthDTO) {
        this.authStore.login({ username: login.username, password: login.password });
    }
}
